import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import NavItem from "../navigation_bar/NavItem";
import "./../../assets/css/nav.css";

const SIDE_NAV_ITEMS = [
    { id: "vocabulary", label: "Flashcards" },
    { id: "test", label: "Testing" },
    { id: "listening", label: "Listening" },
    { id: "alphabet", label: "Alphabet" },
    { id: "storytelling", label: "Storytelling" },
    { id: "music", label: "Music" },
    { id: "review", label: "Review" },
];

const LANGUAGE_META = {
    0: { name: "German", flag: "de.svg" },
    1: { name: "Mexican Spanish", flag: "mx.svg" },
    2: { name: "French", flag: "fr.svg" },
    3: { name: "Russian", flag: "ru.svg" },
    4: { name: "Brazilian Portuguese", flag: "br.svg" }
};


function SideNav({ activeItem, onChange, registeredCourses = [], activeLanguageId = 0, onLanguageChange, mobileOpen = false, onSettingsClick }) {
    const [showDropdown, setShowDropdown] = useState(false);
    const navigate = useNavigate();
    const { logout } = useAuth();

    const handleSignOut = async () => {
        await logout();
        navigate("/");
    };

    const handleSectionClick = (label) => {
        onChange?.(label);
    };

    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

    const handleSelectLanguage = (langId) => {
        onLanguageChange?.(langId);
        setShowDropdown(false);
    };

    const activeMeta = LANGUAGE_META[activeLanguageId] || { name: "German", flag: "de.svg" };

    return (
        <aside className={`side-nav${mobileOpen ? " side-nav--mobile-open" : ""}`} role="navigation" aria-label="Learning sections">
            <nav className="side-nav__primary">
                <ul className="side-nav__list">
                    {SIDE_NAV_ITEMS.map((item) => (
                        <li key={item.id}>
                            <NavItem
                                onClick={() => handleSectionClick(item.label)}
                                active={activeItem === item.label}
                                className="side-nav__item"
                            >
                                {item.label}
                            </NavItem>
                        </li>
                    ))}
                </ul>
                <div className="side-nav__mobile-links">
                    <div className="side-nav__divider" />
                    <a href="#about" className="side-nav__item side-nav__mobile-link">About</a>
                    <a href="#donate" className="side-nav__item side-nav__mobile-link">Donate</a>
                    <button type="button" className="side-nav__item side-nav__mobile-link" onClick={onSettingsClick}>
                        Account settings
                    </button>
                    <button type="button" className="side-nav__item side-nav__mobile-link" onClick={handleSignOut}>
                        Sign Out
                    </button>
                </div>
            </nav>
            <div className="side-nav__bottom" style={{ position: "relative" }}>
                <span className="side-nav__pathway-label">STUDYING</span>
                <button
                    type="button"
                    className="side-nav__language-switch"
                    onClick={toggleDropdown}
                    aria-haspopup="listbox"
                    aria-expanded={showDropdown}
                >
                    <img
                        src={require(`../../assets/images/${activeMeta.flag}`)}
                        alt=""
                        className="side-nav__flag"
                        style={{ borderRadius: "2px", boxShadow: "0 1px 2px rgba(0,0,0,0.1)" }}
                    />
                    <span style={{ textTransform: "capitalize" }}>{activeMeta.name}</span>
                </button>

                {showDropdown && (
                    <div className="side-nav__lang-dropdown">
                        <ul className="side-nav__lang-dropdown-list" role="listbox">
                            {registeredCourses.map((course) => {
                                const langId = parseInt(course.language_id, 10);
                                if (langId === activeLanguageId) return null;
                                const meta = LANGUAGE_META[langId];
                                return (
                                    <li key={course.id}>
                                        <button
                                            type="button"
                                            className="side-nav__lang-dropdown-item"
                                            onClick={() => handleSelectLanguage(langId)}
                                            role="option"
                                            aria-selected={false}
                                        >
                                            {meta?.flag && (
                                                <img
                                                    src={require(`../../assets/images/${meta.flag}`)}
                                                    alt=""
                                                    className="side-nav__flag"
                                                    style={{ borderRadius: "2px", marginRight: "8px" }}
                                                />
                                            )}
                                            <span style={{ textTransform: "capitalize" }}>{meta?.name || course.language}</span>
                                        </button>
                                    </li>
                                );
                            })}
                            {registeredCourses.length <= 1 && (
                                <li className="side-nav__lang-dropdown-empty">
                                    You are only registered to one course. Add more in settings!
                                </li>
                            )}
                        </ul>
                    </div>
                )}
            </div>
        </aside>
    );
}

export default SideNav;

